import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
    color: '#666',
  },
  icon: {
    marginRight: 5,
  },
}));
